import React from "react"
import { AppNavigation } from "app/navigation/app-navigation"
import { LayoutBanners } from "./layout-banners"

export function VerticalNavLayout({ layoutConfig, children }) {
  return (
    <div className="flex flex-1 max-h-svh overflow-hidden">
      <AppNavigation />
      <main className="my-2 mr-2 flex-1 rounded-[10px] border border-gray-200 bg-white overflow-y-auto">
        <LayoutBanners layoutConfig={layoutConfig} />
        {children}
      </main>
    </div>
  )
}
